export const PREP_LESSONS_CHUNK_SIZE = 10;
